export function addPropertyImagePrefix(image) {
  return process.env.REACT_APP_PROPERTY_PHOTOS_URI + image;
}
